export default "__VITE_ASSET__UhKH8YsL__"